import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionArtworkCreatorVariables = Types.Exact<{
  contractAddress: Types.Scalars['String'];
  artworkCreatorPublicKey: Types.Scalars['String'];
}>;


export type CollectionArtworkCreator = { creators: Array<Pick<Types.User, 'publicKey' | 'name' | 'username' | 'profileImageUrl'>> };



export const CollectionArtworkCreatorDocument = /*#__PURE__*/ `
    query CollectionArtworkCreator($contractAddress: String!, $artworkCreatorPublicKey: String!) {
  creators: user(
    where: {artworks: {collection: {contractAddress: {_eq: $contractAddress}}}, publicKey: {_eq: $artworkCreatorPublicKey}, hiddenAt: {_is_null: true}}
    limit: 1
    offset: 0
  ) {
    publicKey
    name
    username
    profileImageUrl
  }
}
    `;

export const useCollectionArtworkCreator = <
      TData = CollectionArtworkCreator,
      TError = ClientError
    >(
      variables: CollectionArtworkCreatorVariables,
      options?: Omit<UseQueryOptions<CollectionArtworkCreator, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionArtworkCreator, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionArtworkCreator, TError, TData>(
      {
    queryKey: ['CollectionArtworkCreator', variables],
    queryFn: hasuraFetcher<CollectionArtworkCreator, CollectionArtworkCreatorVariables>(CollectionArtworkCreatorDocument, variables),
    ...options
  }
    )};

useCollectionArtworkCreator.getKey = (variables: CollectionArtworkCreatorVariables) => ['CollectionArtworkCreator', variables];

export const useInfiniteCollectionArtworkCreator = <
      TData = InfiniteData<CollectionArtworkCreator>,
      TError = ClientError
    >(
      variables: CollectionArtworkCreatorVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionArtworkCreator, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionArtworkCreator, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionArtworkCreator, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionArtworkCreator.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionArtworkCreator, CollectionArtworkCreatorVariables>(CollectionArtworkCreatorDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionArtworkCreator.getKey = (variables: CollectionArtworkCreatorVariables) => ['CollectionArtworkCreator.infinite', variables];


useCollectionArtworkCreator.fetcher = (variables: CollectionArtworkCreatorVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionArtworkCreator, CollectionArtworkCreatorVariables>(CollectionArtworkCreatorDocument, variables, options);
